import type { CSSProperties, ReactElement } from 'react';

import { Card, CardBody, cn } from '@heroui/react';
import { cloneElement } from 'react';
import { useTranslation } from 'react-i18next';

import { AnimateIcon } from '../../vanilla/utils/AnimateIcon/AnimateIcon';

interface Props {
  actionElement?: ReactElement;
  className?: string;
  description?: string;
  icon?: 'error' | 'warning';
  style?: CSSProperties;
  title?: string;
}

export function BaseErrorCard({
  actionElement = undefined,
  className = '',
  description = undefined,
  icon = 'error',
  style = {},
  title = undefined,
}: Props) {
  const { t } = useTranslation('ui');

  return (
    <Card className={cn('aspect-square', className)}>
      <CardBody
        className="flex-col items-center justify-center overflow-hidden"
        style={style}
      >
        <AnimateIcon type={icon} />
        <h1 className="text-center text-xl font-bold">
          {title || t('somethingWrong')}
        </h1>
        {description && <span className="mt-4 text-center">{description}</span>}
        {actionElement &&
          cloneElement(actionElement, {
            className: cn(actionElement.props.className, 'mt-4 w-1/2'),
          })}
      </CardBody>
    </Card>
  );
}
